import EcosystemConnectionRequests from "@/views/tools/EcosystemConnectionRequests";
import EnterpriseConnectionRequests from "@/views/tools/EnterpriseConnectionRequests";
import DiffbotCategories from "@/views/tools/DiffbotCategories";
import ClientsDiscovery from "@/views/tools/ClientsDiscovery";
import Clients from "@/views/tools/Clients";
import BlacklistedClients from "@/views/tools/BlacklistedClients";
import ClientsBlacklistedKeywords from "@/views/tools/BlacklistedClientsWildcard.vue";
import HelperItems from "@/views/tools/HelperItems";
import ReleaseNotes from "@/views/tools/ReleaseNotes.vue";
import UsersSearches from "@/views/tools/usersSearches/UsersSearches.vue";
import UpcomingFeatures from "@/views/tools/UpcomingFeatures.vue";
import AiResponses from "@/views/tools/usersSearches/AiResponses.vue";
import ErrorReports from "@/views/tools/ErrorReports.vue";
import EcosystemsCrawling from "@/views/tools/EcosystemsCrawling.vue";
import AiPrompts from "@/views/tools/ai/AiPrompts.vue";
import AiSequences from "@/views/tools/ai/AiSequences.vue";
import AiFieldsLogs from "@/views/tools/ai/AiFieldsLogs.vue";
import AiChatConversations from "@/views/tools/aiChat/AiChatConversations.vue";
import ElasticConversations from "@/views/tools/usersSearches/ElasticAiChatConversations.vue";

export default [
    {
        path: '/invite-ecosystem-requests',
        component: EcosystemConnectionRequests,
        meta: {
            access: ['admin'],
        }
    },
    {
        path: '/invite-enterprise-requests',
        component: EnterpriseConnectionRequests,
        meta: {
            access: ['admin'],
        }
    },
    {
        path: '/diffbot-categories',
        component: DiffbotCategories,
        meta: {
            access: ['admin'],
        }
    },
    {
        path: '/clients-discovery',
        component: ClientsDiscovery,
        meta: {
            access: ['admin','freelancer'],
        }
    },
    {
        path: '/blacklisted-clients',
        component: BlacklistedClients,
        meta: {
            access: ['admin', 'freelancer'],
        }
    },
    {
        path: '/blacklisted-clients-wildcard',
        component: ClientsBlacklistedKeywords,
        meta: {
            access: ['admin'],
        }
    },
    {
        path: '/clients',
        component: Clients,
        meta: {
            access: ['admin','freelancer'],
        }
    },
    {
        path: '/helper-items',
        component: HelperItems,
        meta: {
            access: ['admin'],
        }
    },
    {
        path: '/release-notes',
        component: ReleaseNotes,
        meta: {
            access: ['admin'],
        }
    },
    {
        path: '/upcoming-features',
        component: UpcomingFeatures,
        meta: {
            access: ['admin'],
        }
    },
    {
        path: '/users-search-history',
        component: UsersSearches,
        meta: {
            access: ['admin'],
        }
    },
    {
        path: '/ai-response-history',
        component: AiResponses,
        meta: {
            access: ['admin'],
        }
    },
    {
        path: '/elastic-conversations',
        component: ElasticConversations,
        meta: {
            access: ['admin'],
        }
    },
    {
        path: '/error-reports',
        component: ErrorReports,
        meta: {
            access: ['admin'],
        }
    },
    {
        path: '/ecosystems-crawling',
        component: EcosystemsCrawling,
        meta: {
            access: ['admin'],
        }
    },
    {
        path: '/ai-prompts',
        component: AiPrompts,
        meta: {
            access: ['admin'],
        }
    },
    {
        path: '/ai-sequences',
        component: AiSequences,
        meta: {
            access: ['admin'],
        }
    },
    {
        path: '/ai-fields-logs',
        component: AiFieldsLogs,
        meta: {
            access: ['admin'],
        }
    },
    {
        path: '/ai-chat-conversations',
        component: AiChatConversations,
        meta: {
            access: ['admin'],
        }
    },
]
